import { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import sidelogo from '../../../src/assets/img/LeadTrack-icon.svg';
import home from '../../../src/assets/img/crm_home/sidemenu/home.svg';
import suspects from '../../../src/assets/img/crm_home/sidemenu/suspect.svg';
import projects from '../../../src/assets/img/crm_home/sidemenu/projects.svg';
import features from '../../../src/assets/img/crm_home/sidemenu/features.svg';
import tasks from '../../../src/assets/img/crm_home/sidemenu/tasks.svg';
import sales from '../../../src/assets/img/crm_home/sidemenu/sales.svg';
import opportunity from '../../../src/assets/img/crm_home/sidemenu/opportunity.svg';
import campaign from '../../../src/assets/img/crm_home/sidemenu/campaign.svg';
import { useMsal } from '@azure/msal-react';
import { useSelector } from 'react-redux';
import apiServices from '../../services/service';
import { getLoggedUserRMData, getUser, getUserMenuPermission, getUserRole } from '../../redux/selector';
import Popover from 'react-bootstrap/Popover';
import settingsIcon from '../../../src/assets/img/crm_home/sidemenu/settings.png';
import identityIcon from '../../../src/assets/img/crm_home/sidemenu/identity1.png';
import masters from '../../../src/assets/img/crm_home/sidemenu/master.svg';
import logout from '../../../src/assets/img/crm_home/sidemenu/logout.svg';
import ImageUploadWithPreview from '../../../src/components/userManagement/imageUploadWithPreview';
import { BlobServiceClient } from '@azure/storage-blob';
import ChangePasswordModal from '../settings/changePassword/changePassword';
// import { useAppAuth } from '../../appAuthContext';
import Password from '../../../src/assets/img/sidemenu/password.png'
import AuditLog from '../../../src/assets/img/sidemenu/AuditLog.png'
import { logoutHandler } from '../../auth/logoutHandle';
import { useAppAuth } from '../../auth/appAuthContext';

const SidebarCRM = ({ visibileMenues, toggleMenu, handleToggleMenu }) => {
  const loggedInUserRMData = useSelector(getLoggedUserRMData);
  const user = useSelector((state) => state.data?.user?.user);
  const [userData, setUserData] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const [imageUrl, setImageUrl] = useState('/assets/images/profile.png');
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [activeButton, setActiveButton] = useState('home');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const popupRef = useRef(null);
  const [showPopover, setShowPopover] = useState(false);
  const [menuVisibility, setMenuVisibility] = useState(visibileMenues);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activePopover, setActivePopover] = useState('');
  const [formEdited, setFormEdited] = useState(false);
  const [imagefile, setImageFile] = useState(null);
  const [imageUploadStatus, setImageUploadStatus] = useState(true);
  const accessableMenu = useSelector(getUserMenuPermission);
  const userRole = useSelector(getUserRole);
  const [showchangePasswordPopup, setShowChangePasswordPopup] = useState(false);
  const userInfo = useSelector(getUser);
  const { authType } = useAppAuth();

  // let hasViewTicketPermission = null;
  // let hasViewLeadPermission = null;
  // let hasViewOpportunityPermission = null;
  // let hasViewContactPermission = null;
  // let hasViewCampaignPermission = null;
  // let hasViewAccountPermission = null;
  // let hasViewQuoteAIPermission = null;
  // let hasViewTemplatePermission = null;
  // let hasViewSalesPermission = null;
  // let hasViewProductPermission = null;
  // const userInformation = JSON.parse(localStorage.getItem("userInformation"));
  // const role = userInformation?.role || "";
  const isAdminOrSystemManager = userRole === 'Admin' || userRole === 'System Manager';
  // const isSystemManager = role === "System Manager";
  // let userUIControlPermission = JSON.parse(
  //   localStorage.getItem("userUIControlPermission")
  // );
  // if (userUIControlPermission) {
  const hasViewTicketPermission = accessableMenu?.ticketmenu?.ticketviewscreen?.canView;
  const hasViewLeadPermission = accessableMenu?.leadmenu?.leadviewscreen?.canView;
  const hasViewOpportunityPermission =
    accessableMenu?.opportunitymenu?.opportunityviewscreen?.canView;
  const hasViewContactPermission = accessableMenu?.contactmenu?.contactviewscreen?.canView;
  const hasViewCampaignPermission =
    accessableMenu?.campaignmenu &&
    (accessableMenu?.campaignmenu?.campaignsmenu?.campaignsviewscreen?.canView ||
      accessableMenu?.campaignmenu?.smartsequencemenu?.smartsequenceviewscreen?.canView);
  const hasViewAccountPermission = accessableMenu?.accountmenu?.accountviewscreen?.canView;
  const hasViewTemplatePermission = accessableMenu?.templatemenu?.templateviewscreen?.canView;
  const hasViewQuoteAIPermission = accessableMenu?.quotemenu?.quoteviewscreen?.canView;
  const hasViewSalesPermission =
    accessableMenu?.salemenu &&
    (accessableMenu?.salemenu?.invoicemenu?.invoiceviewscreen?.canView ||
      accessableMenu?.salemenu?.salesordermenu?.salesorderviewscreen?.canView);
  const hasViewProductPermission =
    accessableMenu?.productmenu &&
    (accessableMenu?.productmenu?.pricelistmenu?.pricelistviewscreen?.canView ||
      accessableMenu?.productmenu?.productmenu?.productviewscreen?.canView);
  // }

  useEffect(() => {
    const handleClickOutside = (event) => {
      const unifiedPopover = document.querySelector('.sidebar-popover');

      if (unifiedPopover && !unifiedPopover.contains(event.target)) {
        setShowPopover(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    setMenuVisibility(visibileMenues);
  }, [visibileMenues]);

  const gotoUsermanagement = () => {
    navigate('/settings/users');
    closePopover();
  };

  const gotoUiPermissions = () => {
    navigate('/settings/uiPermissions');
    closePopover();
  };

  const gotoTeamUiPermissions = () => {
    navigate('/settings/teamUiPermissions');
    closePopover();
  };

  const gotoActionPermissions = () => {
    navigate('/settings/actionPermissions');
    closePopover();
  };

  const gotoRolemanagement = () => {
    navigate('/settings/roleManagement');
    closePopover();
  };

  const gotoTeammanagement = () => {
    navigate("/settings/teamManagement");
    closePopover();
  };

  const gotoUserActivity = () => {
    navigate('/settings/userActivity');
    closePopover();
  };

  const gotoTemplates = () => {
    navigate('/settings/templates');
    closePopover();
  };

  const gotoDemoPpt = () => {
    window.open(
      'https://docs.google.com/presentation/d/1wwNzoUgqWkxqTI42ese9f0WZjij7D1VqbG2avtaI8uM',
      '_blank', // Opens in new tab
      'noopener,noreferrer' // Security
    );
    closePopover();
  };

  const gotoAuditLog = () => {
    navigate('/settings/auditLog');
    closePopover();
  };

  const openChangePasswordPopup = () => {
    window.open(
      'https://docs.google.com/presentation/d/1wwNzoUgqWkxqTI42ese9f0WZjij7D1VqbG2avtaI8uM',
      '_blank', // Opens in new tab
      'noopener,noreferrer' // Security
    );
    closePopover();
  };

  const unifiedPopover = (
    <Popover id="sidebar-popover" className={`sidebar-popover ${activePopover ? 'show' : ''}`}>
      <div className="sidebar-popover">
        <Popover.Body>
          {activePopover === 'settings' && (
            <div className="parent-div">
              <div className="popover-content"></div>
              <div className="popover-content">
                <div className="popover-img" onClick={gotoTemplates}>
                  <div>
                    <img src="/assets/images/role-management-icons/template.png" alt="" />
                  </div>
                  <h3>Template</h3>
                </div>
                {/* <div className="popover-img noHover"></div> */}
              </div>
            </div>
          )}
          {activePopover === 'identity' && (
            <div className="parent-div">
              <div className="popover-content">
                <div className="popover-img" onClick={gotoActionPermissions}>
                  <div>
                    <img src="/assets/images/role-management-icons/customer(1).png" alt="" />
                  </div>
                  <h3>Action Permission</h3>
                </div>
                <div className="popover-img" onClick={gotoUiPermissions}>
                  <div>
                    <img src="/assets/images/role-management-icons/UI_Permissions.png" alt="" />
                  </div>
                  <h3>UI Permission</h3>
                </div>
              </div>
              <div className="popover-content">
                <div className="popover-img" onClick={gotoUsermanagement}>
                  <div>
                    <img src="/assets/images/role-management-icons/account-settings.png" alt="" />
                  </div>
                  <h3>User Management</h3>
                </div>
                <div className="popover-img" onClick={gotoRolemanagement}>
                  <div>
                    <img src="/assets/images/role-management-icons/coordinate.png" alt="" />
                  </div>
                  <h3>Role Management</h3>
                </div>
                <div className="popover-img" onClick={gotoTeammanagement}>
                  <div>
                    <img
                      src="/assets/images/role-management-icons/coordinate.png"
                      alt=""
                    />
                  </div>
                  <h3>Team Management</h3>
                </div>
              </div>
              <div className="popover-content"></div>
            </div>
          )}
        </Popover.Body>
      </div>
    </Popover>
  );

  const openPopover = (type) => {
    setActivePopover((prev) => (prev === type ? null : type));
  };

  const closePopover = () => {
    setActivePopover(null);
  };

  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);

    if (window.innerWidth <= 767) {
      handleToggleMenu();
    }
  };
  // const handleLogout = async () => {
  //   try {
  //     await instance.logout();
  //     localStorage.clear();
  //     sessionStorage.clear();
  //     document.cookie.split(';').forEach((cookie) => {
  //       const name = cookie.split('=')[0];
  //       document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
  //     });
  //     clearCache('error');
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  useEffect(() => {
    setActiveButton(location.pathname); // Update activeButton when the location changes
  }, [location.pathname]);

  useEffect(() => {
    if (imageUploadStatus && user?.userName) {
      apiServices
        .getBlobImage(user?.userName)
        .then((imageUrl) => {
          setImageUrl(imageUrl);
          setImageUploadStatus(false);
        })
        .catch((error) => { });
    }
  }, [user, imageUploadStatus]);
  useEffect(() => {
    if (loggedInUserRMData && user) {
      // Merge both objects and store in userData
      setUserData({
        ...user,
        ...loggedInUserRMData,
      });
    }
  }, [loggedInUserRMData, user]);

  const handleUploadImage = async (imagefile) => {
    if (!imagefile) return;
    setImageFile(imagefile); // Optional if needed elsewhere
    setFormEdited(true);
    await saveUploadImage(imagefile); // ✅ Pass imagefile directly
  };

  const saveUploadImage = async (imagefile) => {
    const sasUrl = process.env.REACT_APP_AZURE_STORAGE_SAS_URL;
    const blobServiceClient = new BlobServiceClient(sasUrl);
    const containerName = process.env.REACT_APP_AZURE_STORAGE_CONTAINER_NAME;
    const containerClient = blobServiceClient.getContainerClient(containerName);

    if (imagefile && user?.userName) {
      const newFile = new File([imagefile], user?.userName, {
        type: imagefile.type,
      });

      try {
        const blockBlobClient = containerClient.getBlockBlobClient(newFile.name);
        await blockBlobClient.uploadBrowserData(newFile); // Correct method
        setIsModalOpen(false);
        setImageFile(null);
        toast.success('Profile Image Uploaded successfully!', {
          position: 'top-right',
        });
        setImageUploadStatus(true);
      } catch (error) {
        console.error('Error uploading file:', error.message);
        alert('File upload failed. See console for details.');
        setImageUploadStatus(false);
      } finally {
        setFormEdited(false);
      }
    }
  };

  const [isSubMenuVisible, setIsSubMenuVisible] = useState(null); // default to `null` not `false`
  const subMenuRef = useRef({ settings: null, identity: null });

  const handleShowSubMenu = (key) => {
    setIsSubMenuVisible((prev) => (prev === key ? null : key));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const settingsRef = subMenuRef.current.settings;
      const identityRef = subMenuRef.current.identity;

      // If clicked outside both popovers
      if (
        settingsRef &&
        identityRef &&
        !settingsRef.contains(event.target) &&
        !identityRef.contains(event.target)
      ) {
        setIsSubMenuVisible(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleClickAndClose = (callback) => {
    callback();
    setIsSubMenuVisible(null);
    setIsModalOpen(false);
  };

  const identityPages = [
    '/settings/actionPermissions',
    '/settings/uiPermissions',
    '/settings/users',
    '/settings/roleManagement',
    '/settings/teamUiPermissions'
  ];
  const isIdentityActive = identityPages.some((path) => activeButton.includes(path));

  return (
    <>
      {/* <ToastContainer /> */}

      {toggleMenu && (
        <div className="crmsidemenu" onClick={() => setIsModalOpen(false)}>
          <div className="crmlogo">
            <img src={sidelogo} alt="sidelogo" />
          </div>
          <nav className="crm_sidemenu">
            <Link
              className={`crm_sidebtn ${activeButton === '/crm' || activeButton === '/dashboard' ? 'active' : ''}`}
              onClick={() => handleButtonClick('home')}
              to="/dashboard"
            >
              <img src={home} alt="home" />
              <span>Home</span>
            </Link>

            {menuVisibility?.leadmenu && (
              <>
                {hasViewLeadPermission ? (
                  <Link
                    className={`crm_sidebtn ${activeButton === '/crm/leads' || activeButton.includes('/leads') ? 'active' : ''}`}
                    onClick={() => handleButtonClick('/crm/leads')}
                    to="/leads"
                  >
                    <img src={suspects} alt="leads" />
                    <span>Leads</span>
                  </Link>
                ) : (
                  <div className="crm_sidebtn disabledLink">
                    <img src={suspects} alt="leads" />
                    <span>Leads</span>
                  </div>
                )}
              </>
            )}

            {menuVisibility?.contactmenu && (
              <>
                {hasViewContactPermission ? (
                  <Link
                    className={`crm_sidebtn ${activeButton === '/crm/contacts' || activeButton.includes('/contacts') ? 'active' : ''}`}
                    onClick={() => handleButtonClick('/crm/contacts')}
                    to="/contacts"
                  >
                    <img src={projects} alt="projects" />
                    <span>Contacts</span>
                  </Link>
                ) : (
                  <div className="crm_sidebtn disabledLink">
                    <img src={projects} alt="projects" />
                    <span>Contacts</span>
                  </div>
                )}
              </>
            )}

            {menuVisibility?.accountmenu && (
              <>
                {hasViewAccountPermission ? (
                  <Link
                    className={`crm_sidebtn ${activeButton === '/crm/accounts' || activeButton.includes('/accounts') ? 'active' : ''}`}
                    onClick={() => handleButtonClick('/crm/accounts')}
                    to="/accounts"
                  >
                    <img src={features} alt="Features" />
                    <span>Accounts</span>
                  </Link>
                ) : (
                  <div className="crm_sidebtn disabledLink">
                    <img src={features} alt="Features" />
                    <span>Accounts</span>
                  </div>
                )}
              </>
            )}

            {menuVisibility?.opportunitymenu && (
              <>
                {hasViewOpportunityPermission ? (
                  <Link
                    className={`crm_sidebtn ${activeButton === '/crm/opportunity' || activeButton.includes('/opportunity') ? 'active' : ''}`}
                    onClick={() => handleButtonClick('/crm/opportunity')}
                    to="/opportunity"
                  >
                    <img src={opportunity} alt="opportunity" />
                    <span>Opportunity</span>
                  </Link>
                ) : (
                  <div className="crm_sidebtn disabledLink">
                    <img src={opportunity} alt="opportunity" />
                    <span>Opportunity</span>
                  </div>
                )}
              </>
            )}

            {menuVisibility?.campaignmenu && (
              <>
                {hasViewCampaignPermission ? (
                  <Link
                    className={`crm_sidebtn ${activeButton === '/crm/campaigns' || activeButton.includes('/campaigns') ? 'active' : ''}`}
                    onClick={() => handleButtonClick('campaigns')}
                    to="/campaigns"
                  >
                    <img src={campaign} alt="campaigns" />
                    <span>Campaign</span>
                  </Link>
                ) : (
                  <div className="crm_sidebtn disabledLink">
                    <img src={campaign} alt="campaigns" />
                    <span>Campaign</span>
                  </div>
                )}
              </>
            )}

            {menuVisibility?.quotemenu && (
              <>
                {hasViewQuoteAIPermission ? (
                  <Link
                    className={`crm_sidebtn ${activeButton === '/crm/quoteAI' || activeButton.includes('/quoteAI') ? 'active' : ''}`}
                    onClick={() => handleButtonClick('/crm/quoteAI')}
                    to="/quoteAI"
                  >
                    <img src={tasks} alt="tickets" />
                    <span>Quote AI</span>
                  </Link>
                ) : (
                  <div className="crm_sidebtn disabledLink">
                    <img src={tasks} alt="tickets" />
                    <span>Quote AI</span>
                  </div>
                )}
              </>
            )}
            {/* 
           {menuVisibility?.quotemenu && ( 
            <>
              {hasViewQuoteAIPermission ? (
                <Link
                  className={`crm_sidebtn ${activeButton === "pncQuote/dashboard" || activeButton === "pncQuote/dashboard" ? "active" : ""}`}
                  onClick={() => handleButtonClick("pncQuote/dashboard")}
                  to="pncQuote/dashboard"
                >
                  <img src={tasks} alt="tickets" />
                  <span>Quotes Ai</span>
                </Link>
              ) : (
                <div className="crm_sidebtn disabledLink">
                  <img src={tasks} alt="tickets" />
                  <span>Quotes Ai</span>
                </div>
              )}
            </>
        )}  */}

            {menuVisibility?.salemenu && (
              <>
                {hasViewSalesPermission ? (
                  <Link
                    className={`crm_sidebtn ${activeButton === '/sales/salesOrder' || activeButton.includes('/sales') ? 'active' : ''}`}
                    onClick={() => handleButtonClick('/sales/salesOrder')}
                    to="/sales/salesOrder"
                  >
                    <img src={sales} alt="sales" />
                    <span>Sales</span>
                  </Link>
                ) : (
                  <div className="crm_sidebtn disabledLink">
                    <img src={sales} alt="sales" />
                    <span>Sales</span>
                  </div>
                )}
              </>
            )}

            {menuVisibility?.ticketmenu && (
              <>
                {hasViewTicketPermission ? (
                  <Link
                    className={`crm_sidebtn ${activeButton === '/crm/tickets' || activeButton.includes('/tickets') ? 'active' : ''}`}
                    onClick={() => handleButtonClick('/crm/tickets')}
                    to="/tickets"
                  >
                    <img src={tasks} alt="tickets" />
                    <span>Tickets</span>
                  </Link>
                ) : (
                  <div className="crm_sidebtn disabledLink">
                    <img src={tasks} alt="tickets" />
                    <span>Tickets</span>
                  </div>
                )}
              </>
            )}

            {menuVisibility?.productmenu && (
              <>
                {hasViewProductPermission ? (
                  <Link
                    className={`crm_sidebtn ${activeButton === '/products/productList' || activeButton.includes('/products') ? 'active' : ''}`}
                    onClick={() => handleButtonClick('/products/productList')}
                    to="/products/productList"
                  >
                    <img src={masters} alt="Masters" />
                    <span>Products</span>
                  </Link>
                ) : (
                  <div className="crm_sidebtn disabledLink">
                    <img src={tasks} alt="Products" />
                    <span>Products</span>
                  </div>
                )}
              </>
            )}
          </nav>
          <div className="profile-crm"></div>

          <div className="crmprofile_wrapper mb-3">
            <button
              className="crmprofile_btn"
              onClick={(e) => {
                e.stopPropagation(); // Prevents the sidebar click from closing it immediately
                setIsModalOpen(true); // Opens the modal
              }}
            >
              <img src={imageUrl} alt="User Profile" />
            </button>
          </div>
        </div>
      )}

      <div
        className={`custom-offcanvas userPro animate__animated  ${isModalOpen ? 'open' : ''}`}
        style={{ visibility: isModalOpen ? 'visible' : 'hidden' }}
      >
        <div className="offcanvas-body">
          <div className="offcanvas_content px-0">
            <div className="profileContent">
              <div className="profileHeader userPro" id="personal-setting">
                <button className="custom-btn-close" onClick={() => setIsModalOpen(false)}></button>
                {!user && (
                  <>
                    <div className="p-4">Loading...</div>
                  </>
                )}
                {user && (
                  <>
                    <ImageUploadWithPreview
                      uploadFile={handleUploadImage}
                      defaultImageURL={imageUrl}
                    />
                    <div className="account_info_container ms-3 mt-3">
                      <div className="account_info">
                        <div className="userNameDiv">
                          {user?.firstName} {user?.lastName}
                        </div>
                        <div className="mgBot">{user?.email}</div>
                        <div className="lgBlock">
                          {user.roles?.map((role, index) => (
                            <div key={index} className="adminid">
                              {role.roleName}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="otherLinks ">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12">
                    {isAdminOrSystemManager && (
                      <>
                        <div className="otherLinksHdr">
                          <img src={identityIcon} alt="Identity" />
                          <h2>Identity</h2>
                        </div>
                        <div className="popover-content">
                          <div className="row">
                            {/* <div className="col-6 col-sm-6 col-md-4">
                            <div className="popover-img" onClick={() => handleClickAndClose(gotoActionPermissions)}>
                              <div>
                                <img
                                  src="/assets/images/role-management-icons/customer(1).png"
                                  alt=""
                                />
                              </div>
                              <h3>Action Permission</h3>
                            </div>
                          </div> */}
                            <div className="col-6 col-sm-6 col-md-4">
                              <div
                                className="popover-img"
                                onClick={() => handleClickAndClose(gotoActionPermissions)}
                              >
                                <div>
                                  <img
                                    src="/assets/images/role-management-icons/customer(1).png"
                                    alt=""
                                  />
                                </div>
                                <h3>Action Permission</h3>
                              </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-4">
                              <div
                                className="popover-img"
                                onClick={() => handleClickAndClose(gotoUiPermissions)}
                              >
                                <div>
                                  <img
                                    src="/assets/images/role-management-icons/UI_Permissions.png"
                                    alt=""
                                  />
                                </div>
                                <h3>UI Permission</h3>
                              </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-4">
                              <div
                                className="popover-img"
                                onClick={() => handleClickAndClose(gotoUsermanagement)}
                              >
                                <div>
                                  <img
                                    src="/assets/images/role-management-icons/account-settings.png"
                                    alt=""
                                  />
                                </div>
                                <h3>User Management</h3>
                              </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-4">
                              <div
                                className="popover-img"
                                onClick={() => handleClickAndClose(gotoRolemanagement)}
                              >
                                <div>
                                  <img
                                    src="/assets/images/role-management-icons/coordinate.png"
                                    alt=""
                                  />
                                </div>
                                <h3>Role Management</h3>
                              </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-4">
                              <div
                                className="popover-img"
                                onClick={() => handleClickAndClose(gotoTeammanagement)}
                              >
                                <div>
                                  <img
                                    src="/assets/images/role-management-icons/coordinate.png"
                                    alt=""
                                  />
                                </div>
                                <h3>Team Management</h3>
                              </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-4">
                              <div
                                className="popover-img"
                                onClick={() => handleClickAndClose(gotoUserActivity)}
                              >
                                <div>
                                  <img
                                    src="/assets/images/role-management-icons/account-settings.png"
                                    alt=""
                                  />
                                </div>
                                <h3>User Activity</h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="col-12 col-sm-12 col-md-12">
                    {menuVisibility?.templatemenu && (
                      <>
                        {hasViewTemplatePermission && (
                          <>
                            <div className="otherLinksHdr pt-2">
                              <img src={settingsIcon} alt="Settings" />
                              <h2>Settings</h2>
                            </div>
                            <div className="popover-content">
                              <div className="row">
                                <div className="col-6 col-sm-6 col-md-4">
                                  <div
                                    className="popover-img"
                                    onClick={() => handleClickAndClose(gotoTemplates)}
                                  >
                                    <div>
                                      <img
                                        src="/assets/images/role-management-icons/template.png"
                                        alt=""
                                      />
                                    </div>
                                    <h3>Template</h3>
                                  </div>
                                </div>
                                <div className="col-6 col-sm-6 col-md-4">
                                  <div className="popover-img" title="Will be available soon...">
                                    <div>
                                      <img
                                        src="/assets/images/role-management-icons/notification-config.png"
                                        alt="Notification Configuration"
                                      />
                                    </div>
                                    <h3>Notification Configuration</h3>
                                  </div>
                                </div>
                                <div className="col-6 col-sm-6 col-md-4">
                                  <div
                                    className="popover-img"
                                    onClick={() => handleClickAndClose(gotoDemoPpt)}
                                  >
                                    <div>
                                      <img
                                        src="/assets/images/role-management-icons/demo_ppt.png"
                                        alt="Notification Configuration"
                                        style={{ width: '50px' }}
                                      />
                                    </div>
                                    <h3>Demo PPT</h3>
                                  </div>
                                </div>
                                <div className="col-6 col-sm-6 col-md-4">
                                  <div
                                    className="popover-img"
                                    onClick={() => handleClickAndClose(gotoAuditLog)}
                                  >
                                    <div>
                                      <img
                                        src={AuditLog}
                                        alt="Audit Log"
                                        style={{ width: '50px' }}
                                      />
                                    </div>
                                    <h3>Audit Log</h3>
                                  </div>
                                </div>
                                {authType === "db" && (
                                  <div className="col-6 col-sm-6 col-md-4">
                                    <div
                                      className="popover-img"
                                      onClick={() => {
                                        setShowChangePasswordPopup(true);
                                        setIsModalOpen(false); // optional: close profile panel
                                      }}
                                    >
                                      <div>
                                        <img
                                          src={Password}
                                          alt="Change Password"
                                          style={{ width: '50px' }}
                                        />
                                      </div>
                                      <h3>Change Password</h3>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="offcanvas-footer">
          <Link onClick={logoutHandler} className="btn btn-outline-primary logoutBtn me-2">
            <img src={logout} alt="Logout" /> <span>Logout</span>
          </Link>
        </div>
      </div>

      {isModalOpen && (
        <>
          <div
            className={`custom-backdrop ${isModalOpen ? 'show' : ''}`}
            onClick={() => setIsModalOpen(false)}
          ></div>
        </>
      )}
      {showchangePasswordPopup && (
        <>
          <div
            className={`custom-backdrop ${showchangePasswordPopup ? 'show' : ''}`}
            onClick={() => setShowChangePasswordPopup(false)}
          ></div>
          <ChangePasswordModal
            show={showchangePasswordPopup}
            onHide={() => setShowChangePasswordPopup(false)}
          />
        </>
      )}
    </>
  );
};

export default SidebarCRM;
